"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { Separator } from "@/components/ui/separator";
const footerLinkColumns = [{
  title: "Quick Links",
  links: [{
    label: "About Us",
    href: "/AboutUsPage"
  }, {
    label: "Services",
    href: "/ServicesPage"
  }, {
    label: "Careers",
    href: "/CareersPage"
  }]
}, {
  title: "Our Services",
  links: [{
    label: "Personal Care",
    href: "/ServicesPage"
  }, {
    label: "Live-in Care",
    href: "/ServicesPage"
  }, {
    label: "Respite Care",
    href: "/ServicesPage"
  }]
}, {
  title: "Legal",
  links: [{
    label: "Terms & Conditions",
    href: "#"
  }, {
    label: "Privacy Policy",
    href: "#"
  }, {
    label: "CQC Compliance",
    href: "#"
  }]
}];
export default function ComprehensiveFooter() {
  return <section data-section-id="253310" id="footer" className="bg-background pt-16 pb-8 border-t border-border">
      <div className="page-container">
        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8 lg:gap-12 mb-12">
          {}
          <div className="lg:col-span-2">
            <Link to="/HomePage" className="inline-block mb-6">
              <WvcLogo className="h-12 w-auto text-primary" />
            </Link>
            <p className="text-sm text-muted-foreground max-w-xs leading-relaxed">
              Compassionate home care services in Brighton & Hove, dedicated to enhancing quality of life with dignity and professional excellence.
            </p>
          </div>

          {}
          {footerLinkColumns.map((column, i) => <div key={i} data-index={i} className="flex flex-col">
              <h3 className="font-semibold text-foreground mb-4 font-default text-sm tracking-wide">
                {column.title}
              </h3>
              <ul className="space-y-3">
                {column.links.map((link, j) => <li key={j} data-index={j}>
                    <Link to={link.href} className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>)}

          {}
          <div className="flex flex-col">
            <h3 className="font-semibold text-foreground mb-4 font-default text-sm tracking-wide">
              Contact
            </h3>
            <div className="space-y-3">
              <p className="text-sm text-muted-foreground leading-relaxed">
                Ebenezer Church, Richmond Parade<br />
                Brighton, BN2 9AA
              </p>
              <Link to="mailto:info@cynthyleehealthcare.com" className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200 break-all block">
                info@cynthyleehealthcare.com
              </Link>
              <p className="text-sm text-muted-foreground">01273 987001</p>
            </div>
          </div>
        </div>

        <Separator className="my-8 bg-border/40" />

        {}
        

        <Separator className="my-8 bg-border/40" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground">
          <p>© 2026 Cynthylee Health Care. All rights reserved.</p>
          <p className="text-center md:text-right">
            Registered in England & Wales. Providing premium home care with compassion.
          </p>
        </div>
      </div>
    </section>;
}